import { ACTION, SetConsumersAction, SET_CONSUMERS } from "Redux/actionTypes";
import { Consumer } from "Models/consumer";

const initialState: Consumer[] = [];

export default function reduce(state = initialState, action: ACTION) {
    switch (action.type) {
        case SET_CONSUMERS: {
            const {
                payload: { consumers },
            } = action as SetConsumersAction;
            return [...consumers];
        }
        default:
            return state;
    }
}
